import { Dialog, DialogContent, DialogTitle, DialogDescription } from './chunk-DAJW2H54.js';
import { cn } from './chunk-FFX3LZW7.js';
import * as React from 'react';
import { Command as Command$1 } from 'cmdk';
import { Search } from 'lucide-react';
import { jsx, jsxs } from 'react/jsx-runtime';

var DEFAULT_COMMAND_LABEL = "Search";
var Command = React.forwardRef(function Command2({ className, label, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    Command$1,
    {
      ref,
      label: label || DEFAULT_COMMAND_LABEL,
      className: cn(
        "flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground",
        className
      ),
      ...props
    }
  );
});
var CommandInput = React.forwardRef(function CommandInput2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsxs("div", { className: "flex items-center border-b px-3", children: [
    /* @__PURE__ */ jsx(Search, { className: "mr-2 h-4 w-4 shrink-0 opacity-50" }),
    /* @__PURE__ */ jsx(
      Command$1.Input,
      {
        ref,
        className: cn(
          "flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
          className
        ),
        ...props
      }
    )
  ] });
});
var CommandList = React.forwardRef(function CommandList2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    Command$1.List,
    {
      ref,
      className: cn("max-h-[300px] overflow-y-auto overflow-x-hidden", className),
      ...props
    }
  );
});
var CommandEmpty = React.forwardRef(function CommandEmpty2(props, ref) {
  return /* @__PURE__ */ jsx(Command$1.Empty, { ref, className: "py-6 text-center text-sm text-muted-foreground", ...props });
});
var CommandGroup = React.forwardRef(function CommandGroup2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    Command$1.Group,
    {
      ref,
      className: cn(
        "overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground",
        className
      ),
      ...props
    }
  );
});
var CommandSeparator = React.forwardRef(function CommandSeparator2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsx(Command$1.Separator, { ref, className: cn("-mx-1 h-px bg-border", className), ...props });
});
var CommandItem = React.forwardRef(function CommandItem2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    Command$1.Item,
    {
      ref,
      className: cn(
        "relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none data-[disabled=true]:pointer-events-none data-[selected=true]:bg-accent data-[selected=true]:text-accent-foreground data-[disabled=true]:opacity-50",
        className
      ),
      ...props
    }
  );
});
function CommandDialog({
  children,
  open,
  onOpenChange,
  /** Accessible name/description for the dialog (rendered visually hidden). */
  label = "Command menu",
  description = "Search and run commands."
}) {
  return /* @__PURE__ */ jsx(Dialog, { open, onOpenChange, children: /* @__PURE__ */ jsxs(DialogContent, { className: "overflow-hidden p-0", showClose: false, children: [
    /* @__PURE__ */ jsx(DialogTitle, { className: "sr-only", children: label }),
    /* @__PURE__ */ jsx(DialogDescription, { className: "sr-only", children: description }),
    /* @__PURE__ */ jsx(Command, { className: "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5", children })
  ] }) });
}

export { Command, CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, CommandSeparator };
//# sourceMappingURL=chunk-MSCJGV3K.js.map
//# sourceMappingURL=chunk-MSCJGV3K.js.map